import { Dialog, DialogContent } from '@material-ui/core';
import React from 'react'
import { useSelector } from 'react-redux';
import TableGeneric from '../../../compartidos/abms/TableGeneric';

const DomiciliosPrestacionales = ({ item }) => {
    const { centrosMedicos } = useSelector((state) => state.contratacionesCartilla);
    const { items: localidades } = useSelector(state => state.localidades)
    const { items: provincias } = useSelector(state => state.provincias)
    const { rankingsCartilla } = useSelector((state) => state.contratacionesCartilla);
    const { items: especialidades } = useSelector((state) => state.especialidades);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const getPrestadoresFormateados = (prestadores) => {
        let formateados = []
        prestadores.forEach((prestador) => {
            prestador.cartillaPrestadores.forEach((cartillaPrestador) => {
                let datosDomicilio = {}
                if (cartillaPrestador.atiendeCentroPropio) {
                    const centroMedico = centrosMedicos.find(
                        (centroMedico) =>
                            centroMedico.idCentroMedico === parseInt(cartillaPrestador.idCentroMedico)
                    );

                    let localidadEncontrada = localidades.find((loc) =>
                        parseInt(loc?.id_localidad) === parseInt(centroMedico?.idLocalidad)
                    );
                    let provinciaEncontrada = provincias.find((prov) =>
                        parseInt(prov?.id_provincia) === parseInt(localidadEncontrada?.id_provincia)
                    );

                    datosDomicilio.domicilio = centroMedico?.direccion;
                    datosDomicilio.cp = centroMedico?.cp;
                    datosDomicilio.telefono = centroMedico?.telefono;
                    datosDomicilio.localidad = localidadEncontrada?.descripcion_localidad;
                    datosDomicilio.idLocalidad = localidadEncontrada.id_localidad
                    datosDomicilio.provincia = provinciaEncontrada?.descripcion_provincia;
                    datosDomicilio.idProvincia = provinciaEncontrada.id_provincia
                } else {
                    let localidadEncontrada = localidades.find((loc) =>
                        parseInt(loc?.id_localidad) === parseInt(cartillaPrestador.cartillaPrestadoresDomicilio?.idLocalidad)
                    );

                    let provinciaEncontrada = provincias.find((prov) =>
                        parseInt(prov?.id_provincia) === parseInt(localidadEncontrada?.id_provincia)
                    );


                    datosDomicilio.domicilio = cartillaPrestador.cartillaPrestadoresDomicilio?.domicilio;
                    datosDomicilio.cp = cartillaPrestador.cartillaPrestadoresDomicilio?.cp;
                    datosDomicilio.telefono = cartillaPrestador.cartillaPrestadoresDomicilio?.telefono;
                    datosDomicilio.localidad = localidadEncontrada?.descripcion_localidad;
                    datosDomicilio.provincia = provinciaEncontrada?.descripcion_provincia;
                }
                let aux = {
                    nombreApellido: prestador.nombreApellido,
                    cuit: prestador.cuit,
                    datosDomicilio,
                    ranking: rankingsCartilla.find(x => x.idRankingCartilla === cartillaPrestador.idRanking)?.descripcion,
                    especialidades: cartillaPrestador.cartillaPrestadoresEspecialidades.map(x => especialidades.find(e => e.idEspecialidades === x)?.descripcionEspecialidades)
                }

                formateados.push(aux)
            })
        })
        return formateados
    }

    const getCantDomicilios = (prestadores) => {
        let auxCantidad = 0;
        prestadores.forEach(element => {
            auxCantidad = auxCantidad + element.cartillaPrestadores.length
        });
        return auxCantidad
    }

    return (
        <>
            <div onClick={handleClickOpen} style={{ cursor: "pointer" }}>
                {getCantDomicilios(item.prestadores) + " domicilios prestacionales"}
            </div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                <DialogContent>
                    <TableGeneric
                        data={getPrestadoresFormateados(item.prestadores)}
                        columns={[
                            {
                                label: "Nombre y Apellido",
                                id: "nombreApellido",
                                sort: true
                            },
                            {
                                label: "Domicilio",
                                id: "datosDomicilio.domicilio",
                                sort: false
                            },
                            {
                                label: "CP",
                                id: "datosDomicilio.cp",
                                sort: false
                            },
                            {
                                label: "Localidad",
                                id: "datosDomicilio.localidad",
                                sort: true,
                            },
                            {
                                label: "Provincia",
                                id: "datosDomicilio.provincia",
                                sort: true,
                            },
                            {
                                label: "Ranking",
                                id: "ranking",
                                sort: false,
                            },
                            {
                                label: "Especialidades",
                                customBody: (item) =>
                                    <ul>
                                        {
                                            item.especialidades.map((e, index) => <li key={index}>{e}</li>)
                                        }
                                    </ul>
                            },
                        ]}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default DomiciliosPrestacionales